<template>
  <div>
    <!-- 轮播图 start -->
    <el-carousel class="carousel-box" trigger="click" height="450px">
      <el-carousel-item v-for="(item, index) in carouselItem" :key="index">
        <el-image class="item-bgc" :src="item.bgcIma"></el-image>
        <div class="info-box">
          <div>
            <h1 class="title">{{ item.text }}</h1>
            <p class="info-tip" v-for="(ele, index) in item.list" :key="index">
              {{ ele }}
            </p>
            <div class="down-btn" @click="toLogin">立即下载</div>
          </div>
          <div>
            <el-image
              style="width: 100%; height: 100%"
              fit="contain"
              :src="item.rightImage"
            ></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图 end -->

    <!-- 会员登录 start -->
    <div class="user-login">
      <p class="login-p">会员注册</p>
      <el-row type="flex" justify="center">
        <el-col :span="8">
          <el-form
            ref="formed"
            :rules="rules"
            :model="setForm"
            label-width="100px"
          >
            <el-form-item label="账号:" prop="user">
              <el-input v-model="setForm.user"></el-input>
            </el-form-item>
            <el-form-item label="密码:" prop="password">
              <el-input v-model="setForm.password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码:" prop="checkpassword">
              <el-input v-model="setForm.checkpassword"></el-input>
            </el-form-item>
            <el-form-item label="姓名:" prop="name">
              <el-input v-model="setForm.name"></el-input>
            </el-form-item>
            <el-form-item label="邮箱:">
              <el-input v-model="setForm.email"></el-input>
            </el-form-item>
            <el-form-item label="手机:" prop="phone">
              <el-row>
                <el-col :span="10">
                  <el-select v-model="setForm.city" placeholder="请选择">
                    <el-option label="中国大陆+86" value="ch"></el-option>
                    <el-option label="香港+852" value="hk"></el-option>
                    <el-option label="澳门+853" value="mc"></el-option>
                    <el-option label="台湾+886" value="tw"></el-option>
                    <el-option label="韩国+82" value="kr"></el-option>
                    <el-option label="日本+81" value="jp"></el-option>
                    <el-option label="美国+1" value="ac"></el-option>
                    <el-option label="加拿大+1" value="cnd"></el-option>
                    <el-option label="英国+44" value="el"></el-option>
                    <el-option label="马来西亚+60" value="mls"></el-option>
                    <el-option label="泰国+66" value="tl"></el-option>
                    <el-option label="越南+84" value="vtn"></el-option>
                    <el-option label="法国+33" value="fc"></el-option>
                    <el-option label="菲律宾+63" value="plp"></el-option>
                    <el-option label="印度尼西亚+62" value="idns"></el-option>
                    <el-option label="意大利+39" value="itl"></el-option>
                    <el-option label="俄罗斯+7" value="rs"></el-option>
                    <el-option label="新西兰+64" value="zl"></el-option>
                    <el-option label="荷兰+31" value="nl"></el-option>
                    <el-option label="瑞典+46" value="swd"></el-option>
                    <el-option label="澳大利亚+61" value="atl"></el-option>
                    <el-option label="德国+49" value="gm"></el-option>
                    <el-option label="新加坡+65" value="snp"></el-option>
                    <el-option label="芬兰+358" value="fld"></el-option>
                    <el-option label="丹麦+45" value="dmk"></el-option>
                    <el-option label="以色列+00972" value="isr"></el-option>
                  </el-select>
                </el-col>
                <el-col :offset="1" :span="13">
                  <el-input v-model="setForm.phone"></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="留言:">
              <el-input v-model="setForm.remark"></el-input>
            </el-form-item>
            <el-form-item label-width="140px">
              <el-button type="primary" @click="submitForm">注册</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <!-- 会员登录 end -->
  </div>
</template>

<script>
import banner1 from "@/assets/imgs/banner-1.png";
import banner2 from "@/assets/imgs/banner-2.png";
import banner1r from "@/assets/imgs/banner-1-right.png";
import banner2r from "@/assets/imgs/banner-2-right.png";
export default {
  data() {
    return {
      setForm: {
        user: "",
        password: "",
        checkpassword: "",
        name: "",
        email: "",
        city: "",
        phone: "",
        remark: ""
      },
      rules: {
        user: [{ required: true, message: "请输入账户", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        checkpassword: [
          { required: true, message: "请确认密码", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入名字", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }]
      },
      carouselItem: [
        {
          bgcIma: banner1,
          rightImage: banner1r,
          text: "企业OA系统软件",
          list: ["●在现办公", "●即时下载", "●会员优惠价：6000元"]
        },
        {
          bgcIma: banner2,
          rightImage: banner2r,
          text: "在线商城软件下载",
          list: [
            "●企业独立运营商城",
            "●助力企业快速进入移动电商时代",
            "●会员优惠价：1800元（不含服务器）"
          ]
        }
      ]
    };
  },
  methods: {
    submitForm() {
      this.$refs["formed"].validate(valid => {
        if (valid) {
          setTimeout(() => {
            this.$alert("网络错误", "温馨提示", {
              confirmButtonText: "确定",
              callback: action => {
                this.$message({
                  type: "info",
                  message: "网络错误"
                });
              }
            });
          }, 1000);
        } else {
          this.$message('请填写必填项');
        }
      });
    },
    toLogin() {
      this.$router.push({
        path: "/userlogin"
      });
    },
    login() {

    }
  }
};
</script>

<style scoped>
.carousel-box {
  overflow: hidden;
}
.item-bgc {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.info-box {
  width: 60%;
  height: 70%;
  background-color: transparent;
  position: absolute;
  left: 50%;
  top: 100px;
  transform: translateX(-50%);
  display: flex;
}
.info-box div {
  flex: 1;
  color: #fff;
  font-size: 18px;
}
.title {
  font-size: 46px;
  padding: 20px 0;
}
.info-tip {
  padding: 5px 0;
}
.down-btn {
  width: 120px;
  text-align: center;
  padding: 10px 20px;
  border: 1px solid #fff;
  cursor: pointer;
  margin-top: 40px;
}

.user-login {
  padding: 10px 300px;
}

.login-p {
  padding-bottom: 10px;
  color: #009fe9;
  border-bottom: 1px solid #b3b3b3;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/userset.vue